import React from 'react';

import { ClientRelianceOpinionInstance } from './store/types';
import { ArkOpinion } from '../my-opinions/store';
import { GeneralSection, ScopeSection, TransactionCoverageSection, CounterpartyCoverageSection, ClauseSection, ClientRelianceAssumptionsSection, ClientRelianceOtherIssues, ClientRelianceCloseOutSetOffAndDefault, ClientRelianceAgreementCoverageSection } from './sections';

interface ClientRelianceInstanceProps {
    instance: ClientRelianceOpinionInstance;
    opinion: ArkOpinion;
    isEditing: boolean;
    isUpdating: boolean;
    width: number;
    nettingEngineFields: string[];
}

export const ClientRelianceInstance: React.FC<ClientRelianceInstanceProps> = ({ instance, opinion, isEditing, isUpdating, width, nettingEngineFields }) => {
    const { content: { general, assumptions, closeOutSetOffAndDefault, otherIssues, agreementCoverage, transactionCoverage, counterpartyCoverage, additionalProvisions }, fieldsUpdated } = instance;
    return (
        <div>
            <GeneralSection general={general} opinion={opinion} isEditing={isEditing} isUpdating={isUpdating} fieldsUpdated={fieldsUpdated} />
            <ScopeSection opinion={opinion} isEditing={isEditing} isUpdating={isUpdating} />
            <ClientRelianceAssumptionsSection assumptions={assumptions} isEditing={isEditing} isUpdating={isUpdating} fieldsUpdated={fieldsUpdated} />
            <ClientRelianceCloseOutSetOffAndDefault closeOutSetOffAndDefault={closeOutSetOffAndDefault} isEditing={isEditing} isUpdating={isUpdating} fieldsUpdated={fieldsUpdated} />
            <ClientRelianceOtherIssues otherIssues={otherIssues} isEditing={isEditing} isUpdating={isUpdating} fieldsUpdated={fieldsUpdated} />
            <ClientRelianceAgreementCoverageSection agreementCoverage={agreementCoverage} isEditing={isEditing} isUpdating={isUpdating} fieldsUpdated={fieldsUpdated} />
            <TransactionCoverageSection transactionCoverage={transactionCoverage} isEditing={isEditing} isUpdating={isUpdating} fieldsUpdated={fieldsUpdated} nettingEngineFields={nettingEngineFields} />
            <CounterpartyCoverageSection counterpartyCoverage={counterpartyCoverage} isEditing={isEditing} isUpdating={isUpdating} fieldsUpdated={fieldsUpdated} jurisdiction={opinion.jurisdiction} nettingEngineFields={nettingEngineFields} />
            <ClauseSection additionalProvisions={additionalProvisions} opinion={opinion} width={width} isEditing={isEditing} isUpdating={isUpdating} fieldsUpdated={fieldsUpdated} />
        </div>
    );
};
